// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"df470f13","977":"1f28981f"}[chunkId] + ".chunk.js";
};